import script from "./orgInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./orgInfo.vue?vue&type=script&setup=true&lang=js"

import "./orgInfo.vue?vue&type=style&index=0&id=04ca8f16&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04ca8f16"]])

export default __exports__